export default __webpack_public_path__ + "static/media/sponsors.8112ad66.svg";